import { ButtonDropdown, ButtonsGroup, NavItem, Tooltip } from '@billy/design-system'
import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useSalesByItemReport } from '../../../../../../hooks/salesByItemReport/useSalesByItemReport'
import { BasicExportActionDropdownItem } from '../../../../../../types/exportActionDropdownItem'
import { getIsExportLimitReached } from '../../../../../../utils/getIsExportLimitReached'
import { EXPORT_ACTIONS_DROPDOWN_WIDTH } from '../../constants/exportActionsDropdownWidth'
import { useSalesByItemReportExportActions } from './hooks/useSalesByItemReportExportActions'

export const SalesByItemReportExportActions = (): ReactElement => {
  const { t } = useTranslation()
  const { isExportDisabled, isExporting, performSalesReportExport } = useSalesByItemReportExportActions()
  const { salesByItemReport } = useSalesByItemReport()

  const isExportLimitReached = getIsExportLimitReached(salesByItemReport.length)
  const isExportButtonDisabled = isExportDisabled || isExportLimitReached

  const dropdownItems = useMemo(
    (): NavItem<BasicExportActionDropdownItem>[] => [
      {
        id: 'exportAsPdf',
        children: t('sales_report.export_button.dropdown_options.export_as_pdf'),
        value: 'exportAsPdf',
      },
      {
        id: 'downloadAsXlsx',
        children: t('sales_report.export_button.dropdown_options.download_as_xlsx'),
        value: 'downloadAsXlsx',
      },
      {
        id: 'downloadAsCsv',
        children: t('sales_report.export_button.dropdown_options.download_as_csv'),
        value: 'downloadAsCsv',
      },
    ],
    [t],
  )

  const handleExportActionsButtonDropdownSelect = async (_: string, selectedAction: BasicExportActionDropdownItem) => {
    performSalesReportExport[selectedAction]()
  }

  return (
    <Tooltip
      forceHidden={!isExportLimitReached}
      label={t('sales_report.export_button.export_limit.tooltip.items')}
      placement="bottom"
    >
      <ButtonsGroup>
        <ButtonDropdown
          disabled={isExportButtonDisabled}
          dropdownWidth={EXPORT_ACTIONS_DROPDOWN_WIDTH}
          items={dropdownItems}
          loading={isExporting}
          onSelect={handleExportActionsButtonDropdownSelect}
          variant="filled"
        >
          {t('sales_report.export_button.dropdown_options.title')}
        </ButtonDropdown>
      </ButtonsGroup>
    </Tooltip>
  )
}
